module.exports = __webpack_public_path__ + "img/PAS_RESERVE_GRILLE_POINTAGE_DESACTIVE.9a71350f.svg";